import { withRouter } from 'react-router-dom';
import { graphql, gql, compose } from 'react-apollo';
import kebabCase from 'lodash/kebabCase';
import get from 'lodash/get';

import ToolForm from '../components/ToolForm';

const CREATE_TOOL_MUTATION = gql`
  mutation addTool(
    $name: String!
    $slug: String!
    $description: String
    $detail: String
    $url: String
    $isOpenSource: Boolean!
    $sourceUrl: String
    $imageId: ID!
    $categoriesIds: [ID!]!
    $featuresIds: [ID!]
    $userId: ID!
  ) {
    createTool(
      name: $name
      slug: $slug
      description: $description
      detail: $detail
      url: $url
      isOpenSource: $isOpenSource
      sourceUrl: $sourceUrl
      imageId: $imageId
      categoriesIds: $categoriesIds
      featuresIds: $featuresIds
      userId: $userId
    ) {
      id
      name
      slug
      description
      image {
        url
      }
    }
  }
`;

const CURRENT_USER_QUERY = gql`
  query currentUser {
    user {
      id
      name
    }
  }
`;

const addToolGraphql = graphql(CREATE_TOOL_MUTATION, {
  props: ({ ownProps, mutate }) => {
    return {
      onSubmit: async toolData => {
        const { history } = ownProps;
        const { name } = toolData;
        toolData.slug = kebabCase(name);
        toolData.userId = get(ownProps, 'data.user.id');

        try {
          const { data } = await mutate({
            variables: toolData,
          });

          history.push(`/tool/${data.createTool.slug}`);
        } catch (error) {
          console.error('error', error);
        }
      },
    };
  },
});

const userGraphql = graphql(CURRENT_USER_QUERY);

export default compose(userGraphql, addToolGraphql, withRouter)(ToolForm);



// WEBPACK FOOTER //
// ./src/App/Tool/containers/ToolForm.js